import { render, staticRenderFns } from "./SpecItemPanel.vue?vue&type=template&id=b73c3bb4&scoped=true&lang=pug&"
import script from "./SpecItemPanel.vue?vue&type=script&lang=js&"
export * from "./SpecItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpecItemPanel.vue?vue&type=style&index=0&id=b73c3bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73c3bb4",
  null
  
)

export default component.exports